import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Observable } from 'rxjs';

import { UserState, LoginModal, ShellActions, AuthActions, RootSelectors, Breadcrumb } from '@opm/ng-core';

import { Store, select } from '@ngrx/store';
import { RootSelectors as FlisRootSelectors, State } from 'core/state';
import * as fromRoot from './reducers';
import { takeWhile, filter, debounceTime } from 'rxjs/operators';
import { CoreLib } from 'shared/models/core-libs';
import { Lookups } from 'core/state/lookup-state';
import { ResetSessionExtended, PostModalLogin } from './core/actions/shell.actions';
import { UserServiceService } from './core/services/user-service.service';
import { AccountService } from './core/services/account.service';

declare var $: any;
declare var core: CoreLib;
declare var baseUrl: string;
declare var externalNgLib: any;

@Component({
    selector: 'angular-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    public user: UserState;
    public processing: boolean = false;

    public breadcrumbs: Observable<Breadcrumb[]>;
    public authenticated: Observable<boolean>;
    public pageSubTitle: string;
    public pageSubTitleText: string;
    public showGlobalActions: boolean = false;
    public modalLoginHtml: string;
    public modalLogin: LoginModal;

    private componentActive: boolean = true;

  constructor(private store: Store<State>, private router: Router, private userService: UserServiceService, private accountService: AccountService) { }

    ngOnInit(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);

            externalNgLib.updateRouteNavigation();
        });

      this.authenticated = this.store.pipe(select(RootSelectors.getAuthenticated), takeWhile(() => this.componentActive));

      this.store.pipe(select(RootSelectors.getUser), takeWhile(() => this.componentActive)).subscribe((user: UserState) => {
        this.user = user;
        //this.user.lastLogin = "Retrieving";
      });

      this.store.pipe(select(RootSelectors.getSessionExtended), takeWhile(() => this.componentActive)).subscribe((extended: boolean) => {
        if (extended) {
          this.sessionExtedned();
        }
      });

      this.store.pipe(select(RootSelectors.getShowModalLogin), takeWhile(() => this.componentActive)).subscribe((showModal: LoginModal) => {
        this.modalLogin = showModal;
        if (showModal.show) {
          this.userLoggedOut();
        }
      });

        this.breadcrumbs = this.store.pipe(select(RootSelectors.getBreadcrumbs));

        this.store.pipe(select(RootSelectors.getProcessing), takeWhile(() => this.componentActive)).subscribe(val => {
            this.processing = val;
        })

        this.store.pipe(select(RootSelectors.navigationRequestParams), filter(val => !!val), takeWhile(() => this.componentActive)).subscribe((params: { routeParams: any[], queryParams?: any }) => {
            if (params.routeParams.length > 0) {
                this.router.navigate(params.routeParams, { queryParams: params.queryParams });
            }
        });

        this.store.pipe(select(RootSelectors.getSuccessMessage), filter(x => !!x), takeWhile(() => this.componentActive), debounceTime(250)).subscribe((message: string) => {
            core.pageBanner.loadResponse(message, { title: 'Success', type: core.pageBanner.bannerTypes.note });
            this.store.dispatch(ShellActions.setSuccessMessage({ message: '', source: '' }));
        });

        this.store.pipe(select(RootSelectors.getErrorMessage), filter(x => !!x), takeWhile(() => this.componentActive), debounceTime(250)).subscribe((message: string) => {
            core.pageBanner.loadResponse(message, { title: 'Error', type: core.pageBanner.bannerTypes.error });;
            this.store.dispatch(ShellActions.setErrorMessage({ message: '', source: '' }));
        });


        //this.loadRequiredData();
    }

    ngOnDestroy(): void {
        this.componentActive = false;
  }

  routeChanged(): void {
    externalNgLib.updateRouteNavigation();
  }

  private sessionExtedned(): void {
    // Set the closed callback to show a banner, then clear closed callback
    $.colorbox({
      onClosed: () => {
        core.pageBanner.loadResponse("You have successfully logged back in", { title: "Login successful", type: core.pageBanner.bannerTypes.note });
        //$.colorbox({ onClosed: () => { } });
      }
    });
    $.colorbox.close();
    this.store.dispatch(new ResetSessionExtended());
  }

  showUserLogin(): void {
    $.colorbox({ title: 'Please Login', width: '60%', height: '60%', html: this.modalLoginHtml, onClosed: () => { }, escKey: true, overlayClose: true, closeButton: true, opacity: 0.6 });

    $('#loginForm').find('input[value="Log in"]').click((e) => {
      event.preventDefault();
      var params = { UserName: $("#Credentials_Username").val(), Password: $("#Credentials_Password").val(), apiLogin: '1' };
      this.store.dispatch(new PostModalLogin({ username: params.UserName, password: params.Password }));
    })
  }

  showLoginForm(loginForm: string, closeCallback: any): void {
    $.colorbox({ title: 'You are logged out', width: '60%', height: '60%', html: loginForm, onClosed: closeCallback, escKey: true, overlayClose: true, closeButton: true, opacity: 0.6 });

    $('#loginForm').find('input[value="Log in"]').click((e) => {
      event.preventDefault();
      var params = { UserName: $("#Credentials_Username").val(), Password: $("#Credentials_Password").val(), apiLogin: '1' };
      this.store.dispatch(new PostModalLogin({ username: params.UserName, password: params.Password }));
    })
  }

  logout(): void {
    const currentUrl = window.location.pathname;
    const encodedCurrentUrl = encodeURIComponent(currentUrl);
    const logoutUrl = `${baseUrl}/Account/Logout?returnUrl=${encodedCurrentUrl}`;

    window.location.href = logoutUrl;
  }

  private userLoggedOut(): void {
    var closed = $.colorbox.onClosed;

    if ($("#colorbox").css("display") == "block") {
      $.colorbox({
        onClosed: () => {
          this.showLoginForm(this.modalLogin.html, closed);
        }
      });
      $.colorbox.close();
    } else {
      this.showLoginForm(this.modalLogin.html, closed);
    }
  }

    public loadRequiredData(): void {
      this.store.dispatch(Lookups.loadAgencies());
      this.store.dispatch(Lookups.loadUnions());
      this.store.dispatch(Lookups.loadOlmrNumbers());
      //this.store.dispatch(Lookups.loadCpdfCodes());
      this.store.dispatch(Lookups.loadBusCodes());

    }
}
